import React from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'

const Root = styled.h4`
  margin: 0;
  font-family: raleway, sans-serif;
  ${({size}) => size === 'normal' 
    ? css`
      font-size: 13px;
      line-height: 1.5;
    ` : css`
      font-size: 12px;
      line-height: 1.2;
    `
  };
  font-weight: 500;
  color: #2d9831;
`

const GoodSpecialTitle = ({
  good: {
    specialTitle,
    outOfStock
  },
  size = 'normal'
}) => {
  if (!specialTitle) return null

  return <Root size={size}>
    <span dangerouslySetInnerHTML={{__html: specialTitle}}/>
  </Root>
}

export default GoodSpecialTitle
